'use strict';

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.object.assign");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InvalidBreakpointError = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _templateObject = _taggedTemplateLiteral(['', ''], ['', '']),
    _templateObject2 = _taggedTemplateLiteral(['\n            ', '\n          '], ['\n            ', '\n          ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponentsBreakpoint = require('@humblebee/styled-components-breakpoint');

var _styledComponentsBreakpoint2 = _interopRequireDefault(_styledComponentsBreakpoint);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _isobject = require('isobject');

var _isobject2 = _interopRequireDefault(_isobject);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // Errors


var InvalidBreakpointError = exports.InvalidBreakpointError = function InvalidBreakpointError(bp, breakpoints) {
  return Error('Invalid breakpoint \'' + bp + '\', choose one of the defined breakpoints: ' + breakpoints.list.join(', '));
};
/** HOC props proxy for dealing with responsive props. */

/* Enhances a styled component with the props responsiveProps
*/


var withResponsiveProps = function withResponsiveProps(WrappedComponent) {
  var mixins = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var responsiveProps = function (_Component) {
    _inherits(responsiveProps, _Component);

    function responsiveProps() {
      _classCallCheck(this, responsiveProps);

      return _possibleConstructorReturn(this, (responsiveProps.__proto__ || Object.getPrototypeOf(responsiveProps)).apply(this, arguments));
    }

    _createClass(responsiveProps, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            breakpoints = _props.breakpoints,
            theme = _props.theme,
            nodeRef = _props.nodeRef,
            props = _objectWithoutProperties(_props, ['breakpoints', 'theme', 'nodeRef']);

        var breakpointUtils = responsiveProps.getBreakpointUtils(theme, breakpoints);
        var groupedMethods = responsiveProps.groupMixinsByBreakpoint(props, breakpointUtils);
        var invokedMethods = responsiveProps.invokeBreakpointMixins(groupedMethods, breakpointUtils);
        var fliteredProps = responsiveProps.filterMixinsFromProps(this.props, Object.keys(mixins));
        return _react2.default.createElement(WrappedComponent, _extends({
          theme: theme
        }, fliteredProps, {
          innerRef: nodeRef,
          responsiveProps: invokedMethods
        }));
      }
    }], [{
      key: 'isBreakpointArg',

      /**
       * Determains if an arguemnt is in the form of a breakpoint map or not.
       * @method isBreakpointArg
       * @param {*} args - The args to be checked.
       * @return {boolean}
       */
      value: function isBreakpointArg(args, breakpoints) {
        var argKeys = Object.keys(args); // Return early if args are not an object

        if (!(0, _isobject2.default)(args)) {
          return false;
        } // Return false if key is unknown to the listed breakpoints


        for (var i = 0; i < argKeys.length; i += 1) {
          if (breakpoints.list.indexOf(argKeys[i]) === -1) {
            return false;
          }
        }

        return true;
      }
      /**
       * Invokes breakpoint mixins
       * @method invokeBreakpointMixins
       * @param {object} mixinsByBreakpint - Map object of mixins grpuped by breakpoint.
       * @return {array} - Tagged template litteral
       */

    }, {
      key: 'invokeBreakpointMixins',
      value: function invokeBreakpointMixins(mixinsByBreakpint, breakpoints) {
        var emptyBp = function emptyBp() {
          return (0, _styledComponents.css)(_templateObject, _styledComponents.css.apply(undefined, arguments));
        };

        return Object.keys(mixinsByBreakpint).reduce(function (acc, bp) {
          //
          var bpMixin = typeof breakpoints[bp] === 'undefined' ? emptyBp : breakpoints[bp];
          return [].concat(_toConsumableArray(acc), [bpMixin(_templateObject2, Object.keys(mixinsByBreakpint[bp]).map(function (method) {
            var args = mixinsByBreakpint[bp][method]; // Return method if args are defined

            return function () {
              return mixins[method][// Invoke function with apply if args are in the form of an array, else use call
              Array.isArray(args) ? 'apply' : 'call'](null, args);
            };
          }))]);
        }, []);
      }
      /**
       * Groups mixin under a matching map key.
       * ie. { xl: { firstMethod: 'argument', secondMethod: 'argument' } }
       * @method groupMixinsByBreakpoint
       * @param {*} props - Props of the wrapped component.
       * @return {object} - Map object of mixins grpuped by breakpoint.
       */

    }, {
      key: 'groupMixinsByBreakpoint',
      value: function groupMixinsByBreakpoint(props, breakpoints) {
        // Create an object wtih placeholders for each keys in the initial breakpoint order
        var group = {};
        group = breakpoints.list.reduce(function (acc, bp) {
          return _extends({}, acc, _defineProperty({}, bp, {}));
        }, {});
        group.noBreakpoint = {};
        var mixinsMap = Object.keys(props).reduce(function (acc, key) {
          if (mixins[key]) {
            if (props[key] === null || typeof props[key] === 'undefined') {
              return group;
            } // Add method to the `noBreakpoint` key, if the props is not an object


            if (!(0, _isobject2.default)(props[key])) {
              group.noBreakpoint[key] = props[key];
              return group;
            } // Add method to it's coresponding breakpoint namespace


            Object.keys(props[key]).forEach(function (bp) {
              // Validate breakpoint
              if (!(breakpoints.list.indexOf(bp) > -1)) {
                throw new InvalidBreakpointError(bp, breakpoints);
              } // Puts the mixins under the correct namespace


              group[bp][key] = props[key][bp];
            });
            return group;
          }

          return group;
        }, {}); // Remove empty keys from group before return

        return Object.keys(mixinsMap).reduce(function (acc, key) {
          return _extends({}, acc, Object.keys(mixinsMap[key]).length > 0 ? _defineProperty({}, key, mixinsMap[key]) : {});
        }, {});
      }
      /**
       * Get's the breakpoints either from props or theme
       * Throws an error if neither is present
       * @method groupMixinsByBreakpoint
       * @param {*} props - Props of the wrapped component.
       * @return {object} - Map object of mixins grpuped by breakpoint.
       */

    }, {
      key: 'getBreakpointUtils',
      value: function getBreakpointUtils(theme, breakpoints) {
        if (typeof breakpoints !== 'undefined') {
          return (0, _styledComponentsBreakpoint2.default)(breakpoints);
        } else if (typeof theme !== 'undefined' && typeof theme.responsiveProps !== 'undefined' && typeof theme.responsiveProps.breakpoints !== 'undefined') {
          return (0, _styledComponentsBreakpoint2.default)(theme.responsiveProps.breakpoints);
        }

        throw new Error('Breakpoints need to be provided either through the prop `breakpoints`, or be present under the theme namesapce `responsiveProps.breakpoints` in a `theme` of a ThemeProvider: https://www.npmjs.com/package/responsive-props#register-breakpoints');
      }
      /**
       * Removes mixins properties from the props object
       * @method filterMixinsFromProps
       * @param {*} props - Props of the wrapped component.
       * @param string[] mixinList - Array of string/keys of the registtred mixins
       * @return {object} - Object filtred out props
       */

    }, {
      key: 'filterMixinsFromProps',
      value: function filterMixinsFromProps(props, mixinList) {
        return Object.keys(props).reduce(function (acc, key) {
          if (mixinList.indexOf(key) === -1) {
            acc[key] = props[key];
          }

          return acc;
        }, {});
      }
    }]);

    return responsiveProps;
  }(_react.Component);

  responsiveProps.defaultProps = {
    breakpoints: undefined,
    theme: {
      responsiveProps: {
        breakpoint: undefined
      }
    }
  };
  responsiveProps.propTypes = {
    breakpoints: _propTypes2.default.shape({}),
    theme: _propTypes2.default.shape({})
  };
  responsiveProps.defaultProps = {
    theme: {}
  };
  return (0, _styledComponents.withTheme)(responsiveProps);
};

withResponsiveProps.displayName = 'responsiveProps';
exports.default = withResponsiveProps;